<template>
  <feature-card-data-row-input
    v-bind="{ ...$props, ...$attrs }"
    :value="value"
    @input="$emit('input', $event)"
    dense
    :items="usersArray"
    item-text="name"
    item-value="id"
    :menu-props="{ offsetY: true }"
    :rules="rules"
    :data-type="dataType"
  />
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardDataRowInput from '@/components/FeatureCardDataRowInput';

export default {
  name: 'UserSelect',
  components: {
    FeatureCardDataRowInput,
  },
  data: () => ({
    dataType: {
      name: 'select',
    },
  }),
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    rules: {
      type: Array,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    users: get('users/users'),
    usersArray() {
      return this.$_objectToArray(this.users);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__title {
  text-align: left;
}
::v-deep .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-select__selection {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
</style>
